import React, { useContext, useState } from 'react'
import styled from 'styled-components'

import AddTaskForm from './AddTaskForm'

import tasksContext from '~/contexts/tasks/tasksContext'
import colors from '~/styles/colors'
import { radius } from '~/styles/vars'

const AddTask: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false)
    const { dispatch } = useContext(tasksContext)

    const uid = (): string => {
        let a = new Uint32Array(3)
        window.crypto.getRandomValues(a)
        return (performance.now().toString(36)+Array.from(a).map(A => A.toString(36)).join("")).replace(/\./g,"")
    }

    const handleSubmit = (event: any) => {
        event.preventDefault()
        const label = event.target.elements.label.value
        if (!label) return
        dispatch({ type: 'add_new_task', data: { label, id: uid() } })
        setIsOpen(false)
    }

    
    const handleClick = () => setIsOpen(!isOpen)

    return (
        <>
            <Button onClick={handleClick}>
                <CrossPart1 isOpen={isOpen} />
                <CrossPart2 isOpen={isOpen} />
            </Button>
            {isOpen && (
                <AddTaskForm handleSubmit={handleSubmit} handleClick={handleClick}></AddTaskForm>
            )}
        </>
    )
}

interface CrossProps {
    isOpen: boolean
}

const size = '7.5rem'

const Button = styled.div`
    z-index: 5;
    border-radius: 50%;
    background-color: ${colors.accent[500]};
    color: ${colors.main[700]};
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    width: ${size};
    height: ${size};
    user-select: none;
    cursor: pointer;
`

const CrossPart = styled.div`
    position: relative;
    width: 4rem;
    height: 0.5rem;
    top: 50%;
    left: 50%;
    background-color: ${colors.main[700]};
    transform-origin: 50% 50%;
    border-radius: ${radius.sm};
`

const CrossPart1 = styled(CrossPart)<CrossProps>`
    transition: 0.25s ease-in-out;
    transform: translate(-50%, -50%) ${({ isOpen }) => isOpen && 'rotate(45deg)'};
`

const CrossPart2 = styled(CrossPart)<CrossProps>`
    top: calc(50% - 0.5rem);
    transition: 0.25s ease-in-out;
    transform: translate(-50%, -50%)
        ${({ isOpen }) => (isOpen ? 'rotate(-45deg)' : 'rotate(90deg)')};
`
export default AddTask
